import axios from 'axios';
import moment from 'moment';
import GlobalsApi from '@/api/Globals';
import store from '../../store/index';
import BaseHelper from './base';
import { useBetslipStore } from '../../store/piniaStore/betslip';

export default class Helper extends BaseHelper
{
    static init()
    {
        super.init();
        let lobbyUrl = '';

        window.subscribeToTopic('betslipToggleOnlineOffline', async (param) =>
        {
            try
            {
                const betslipStore = useBetslipStore();
                const { type } = param;

                store.dispatch('changeBetslipType', type);
                betslipStore.changeBetslipType(type);

                return true;
            }
            catch (error)
            {
                // fall silently
            }

            return false;
        });

        window.subscribeToTopic('preload', ({ route }) =>
        {
            if (route.query.language != null)
            {
                route.params.lang = route.query.language;
            }

            if (route.query.lobbyUrl != null)
            {
                lobbyUrl = route.query.lobbyUrl;
            }
        });

        window.authenticateToken = async (param) =>
        {
            const { get, post } = axios;

            const reqParams = { token: param.token };
            const requestAdditionalParameters = {};

            if (param.query.clientId)
            {
                reqParams.requestRealmId = param.query.clientId;
                requestAdditionalParameters.requestRealmId = param.query.clientId;
                store.dispatch('setRequestRealmId', { requestRealmId: param.query.clientId });
            }

            const response = await GlobalsApi.authenticateToken(reqParams);

            if (param.query.clientId)
            {
                requestAdditionalParameters.requestRealmId = param.query.clientId;
            }

            if (response && response.data && response.data.sessionId)
            {
                store.dispatch('setPlayerData', {
                    money: {
                        balance: response.data.TotalBalance,
                        currency: response.data.Currency,
                        createTime: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                    },
                    username: response.data.UserName,
                });
                window.emit('canPlaceOnlineTicketChanged', true);
                requestAdditionalParameters.everymatrixToken = response.data.sessionId;
                store.dispatch('setSessionToken', { everymatrixToken: response.data.sessionId });
                window.emit('setGetBalanceInterval', true);
            }
            else
            {
                window.emit('canPlaceOnlineTicketChanged', false);
            }

            if (Object.keys(requestAdditionalParameters).length)
            {
                axios.get = function getTemp(...args)
                {
                    if (args[1] == null)
                    {
                        args[1] = {};
                    }

                    if (args[1].params == null)
                    {
                        args[1].params = {};
                    }

                    if (param.query.clientId)
                    {
                        args[1].params = {
                            ...requestAdditionalParameters,
                            ...args[1].params,
                        };
                    }

                    return get(...args);
                };

                axios.post = function postTemp(...args)
                {
                    if (args[1] == null)
                    {
                        args[1] = {};
                    }

                    args[1] = {
                        ...requestAdditionalParameters,
                        ...args[1],
                    };

                    return post(...args);
                };
            }
        };

        window.subscribeToTopic('afterload', async (param) =>
        {
            const betslipStore = useBetslipStore();
            if (param.query.freePlay === 'false')
            {
                store.dispatch('changeBetslipType', 'online');
                betslipStore.changeBetslipType('online');
            }
            else
            {
                store.commit('setPlayerData', {
                    money: {
                        balance: 10000,
                        currency: param.query.currencyCode,
                        createTime: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                    },
                });

                store.dispatch('changeBetslipType', 'retail');
                betslipStore.changeBetslipType('retail');
            }
        });

        window.subscribeToTopic('betslipMade', async () =>
        {
            await store.dispatch('getBalance');
        });

        window.subscribeToTopic('betslipError', async (data) =>
        {
            if (data.error)
            {
                if (data.code === 'session_not_valid'
                || data.code === 'token_not_found_or_has_expired')
                {
                    console.log(`Sending window close message: ${lobbyUrl}`);
                    if (lobbyUrl !== null)
                    {
                        window.location = lobbyUrl;
                    }
                }
            }
        });

        window.subscribeToTopic('networkError', async (data) =>
        {
            if (data.error)
            {
                if (data.code === 'request_timed_out'
                || data.code === 'request_server_internal_error'
                || data.code === 'axios_network_error'
                || data.code === 'error: network error')
                {
                    console.log(`Sending window close message: ${lobbyUrl}`);
                    if (lobbyUrl !== null)
                    {
                        window.location = lobbyUrl;
                    }
                }
            }
        });

        const tickets = {};

        window.subscribeToTopic('betChange', async (msg) =>
        {
            const ticket = JSON.parse(msg.data);
            if (ticket.tags.indexOf('template') !== -1)
            {
                if (ticket.status === 'ACTIVE'
                    && tickets[ticket.code] != null)
                {
                    const newBalance = store.getters.playerdata.money.balance - ticket.resolve.calc.payout.sum;
                    store.commit('setMoney', newBalance);
                }
                if (ticket.status === 'ACTIVE'
                    && tickets[ticket.code] == null)
                {
                    const newBalance = store.getters.playerdata.money.balance - ticket.payment.sumTotal;
                    store.commit('setMoney', newBalance);
                    tickets[ticket.code] = ticket;
                }
                else if ((ticket.status === 'WIN' || ticket.status === 'REFUND')
                    && tickets[ticket.code] != null)
                {
                    const newBalance = store.getters.playerdata.money.balance + ticket.resolve.calc.payout.sum;
                    store.commit('setMoney', newBalance);
                    // delete (tickets[ticket.code]); is this needed for something else?
                }
            }
            setTimeout(async () =>
            {
                await store.dispatch('getBalance');
            }, 50);
        });
    }
}
